import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPathologyServiceByClinic } from "../../../store/slices/serviceSlice";
import {
  createClinicPackage,
  resetCreateClinicPackageMessage,
  updateClinicPackage,
  resetUpdateClinicPackageMessage,
  deleteClinicPackage,
  resetDeleteClinicPackageMessage,
  getClinicPackage,
  getClinicPackageById,
} from "../../../store/slices/packageMaster.slice";
import { Modal } from "react-bootstrap";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import classNames from "classnames";
import AddUpdatePackageMaster from "./AddUpdatePackageMaster";
import styles from "./package.module.scss";
import { RiProfileLine } from "react-icons/ri";
import { FaChevronRight } from "react-icons/fa6";
import { TbTestPipe } from "react-icons/tb";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { getClinicTestMasterByClinicId } from "../../../store/slices/clinicTestMaster";
import ViewAllTest from "./viewAllTest";
import { getCategorySlice } from "../../../store/slices/categorySlice";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";

const ClinicTestProfile = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [viewAllclinicPackage, setViewAllclinicPackage] = useState(false);
  const [selectedAction, setSelectedAction] = useState("Create");
  const { userinfo, token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { pathologyServices } = useSelector((state) => state.service);
  const initialState = {
    id: "",
    packageName: "",
    serviceDetails: [],
    clinicId: "",
    clinicName: "",
    clientPrice: "",
    pt_price: "",
    tax: "",
    offerPrice: "",
    status: "Active",
  };
  const [inputError, setInputError] = useState({
    onlyNumber: false,
    text: false,
  });
  const [clinicPackageFormData, setClinicPackageFormData] =
    useState(initialState);
  const dispatch = useDispatch();
  const { clinicTestMasterByClinicId } = useSelector(
    (state) => state.clinicTestMaster,
  );
  const {
    clinicPackageMaster,
    clinicPackageMasterById,
    createClinicPackageSuccessMessage,
    createClinicPackageErrorMessage,
    updateClinicPackageSuccessMessage,
    updateClinicPackageErrorMessage,
    deleteClinicPackageSuccessMessage,
    deleteClinicPackageErrorMessage,
  } = useSelector((state) => state.packageMaster);
  const showMessageAndReset = ShowTostifyMessageAndReset();
  const [searchValue, setSearchValue] = useState("");
  const clinicId =clinicInfo?.[0]?.clinicId || null;
  const clinicObjId = clinicInfo?.[0]?._id;
  useEffect(() => {
    dispatch(
      getClinicPackage({
        token,
        status: ["Active", "Inactive"],
        clinicId,
      }),
    );
    dispatch(getCategorySlice({ token }));
    dispatch(
      getPathologyServiceByClinic({ clinicId, token }),
    );
    dispatch(
      getClinicTestMasterByClinicId({
        clinicId,
        token,
      }),
    );
  }, [
    dispatch,
    viewAllclinicPackage,
    deleteModal,
    modalVisible,
    userinfo,
    clinicId,
    token,
  ]);

  useEffect(() => {
    showMessageAndReset(
      createClinicPackageSuccessMessage,
      showToastifySuccess,
      resetCreateClinicPackageMessage,
    );
    showMessageAndReset(
      createClinicPackageErrorMessage,
      showToastifyError,
      resetCreateClinicPackageMessage,
    );
    showMessageAndReset(
      updateClinicPackageSuccessMessage,
      showToastifySuccess,
      resetUpdateClinicPackageMessage,
    );
    showMessageAndReset(
      updateClinicPackageErrorMessage,
      showToastifyError,
      resetUpdateClinicPackageMessage,
    );
    showMessageAndReset(
      deleteClinicPackageSuccessMessage,
      showToastifySuccess,
      resetDeleteClinicPackageMessage,
    );
    showMessageAndReset(
      deleteClinicPackageErrorMessage,
      showToastifyError,
      resetDeleteClinicPackageMessage,
    );
  }, [
    createClinicPackageSuccessMessage,
    createClinicPackageErrorMessage,
    updateClinicPackageSuccessMessage,
    updateClinicPackageErrorMessage,
    dispatch,
    deleteClinicPackageSuccessMessage,
    deleteClinicPackageErrorMessage,
    showMessageAndReset,
  ]);

  const handlesetClinicPackageFormData = (e, names) => {
    if (names === "pathologyService") {
      const serviceDetailsValues = e?.map((service) => ({
        id: service?.value,
        type: service?.type,
      }));
      setClinicPackageFormData({
        ...clinicPackageFormData,
        serviceDetails: serviceDetailsValues,
      });
    } else {
      setClinicPackageFormData({
        ...clinicPackageFormData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleAddOrUpdatePackage = async (e) => {
    e.preventDefault();
    const { text, onlyNumber } = inputError;
    if (text || onlyNumber) return;
    try {
      if (selectedAction === "Create") {
        await dispatch(
          createClinicPackage({
            ...clinicPackageFormData,
            createdBy: clinicObjId,
            clinicId,
            token,
          }),
        );
      } else {
        await dispatch(
          updateClinicPackage({
            ...clinicPackageFormData,
            updatedBy: clinicObjId,
            clinicId,
            token,
          }),
        );
      }
      setModalVisible(false);
      setClinicPackageFormData(initialState);
    } catch (err) {
      console.error(err);
    }
  };

  const handleEditClinicLabProfile = (data) => {
    setModalVisible(true);
    setSelectedAction("Update");
    const combinedServiceDetails = [
      ...(data?.tests?.map((test) => ({
        id: test?._id || test?.id || "",
        type: "test",
      })) || []),
      ...(data?.profiles?.map((profile) => ({
        id: profile?._id || profile?.id || "",
        type: "profile",
      })) || []),
    ];
    setClinicPackageFormData({
      id: data?._id,
      packageName: data?.packageName,
      serviceDetails: combinedServiceDetails,
      clinicId: data?.clinicId?._id,
      clinicName: data?.clinicId?.clinicName,
      clientPrice: data?.clientPrice,
      pt_price: data?.pt_price,
      tax: data?.tax,
      offerPrice: data?.offerPrice,
      status: data?.status,
    });
  };

  const handleDeleteClick = (data) => {
    setDeleteModal(true);
    setClinicPackageFormData((prevFormData) => ({
      ...prevFormData,
      id: data?._id,
      packageName: data?.packageName,
    }));
  };

  const handleConfirmDelete = async (e) => {
    e.preventDefault();
    try {
      await dispatch(
        deleteClinicPackage({
          id: clinicPackageFormData.id,
          token,
        }),
      );
      setDeleteModal(false);
    } catch (err) {
      console.error(err);
    }
  };

  const handleModal = () => {
    setSelectedAction("Create");
    setModalVisible(true);
    setClinicPackageFormData(initialState);
  };

  const heading = () => (
    <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
      <div className="me-4 d-none d-lg-block">
        <div
          className="btn btn-primary btn-rounded me-4"
          onClick={() => handleModal()}
        >
          + Add Package
        </div>
      </div>
      <div className="input-group search-area ms-auto d-inline-flex me-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search here"
          value={searchValue}
          onChange={handleSearch}
        />
        <div className="input-group-append">
          <button type="button" className="input-group-text">
            <FaSearch className="flaticon-381-search-2" />
          </button>
        </div>
      </div>
    </div>
  );

  const clinicPackageMasterList = () => (
    <div className="row">
      {clinicPackageMaster &&
        clinicPackageMaster?.map((item, index) => {
          const testProfileList = [
            ...(item.tests?.map((test) => test.testName) || []),
            ...(item.profiles?.map((profile) => profile.profileName) || []),
          ];
          return (
            <div
              className="col-xl-3 col-xxl-4 col-lg-6 col-md-6 col-sm-6"
              key={index}
            >
              <div className="card project-boxed">
                <div
                  className={classNames(
                    styles.titel,
                    "card-header",
                    "align-items-start",
                  )}
                >
                  <div className={styles.titelWrapper}>
                    <RiProfileLine />
                    <h6 className="fs-18 font-w500">
                      <Link to={"#"} className="text-black user-name">
                        {item?.packageName}
                      </Link>
                    </h6>
                  </div>
                  <Dropdown className="">
                    <Dropdown.Toggle
                      variant=""
                      as="div"
                      className="btn-link i-false"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                          stroke="#342E59"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                          stroke="#342E59"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                          stroke="#342E59"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu align={"end"}>
                      <Dropdown.Item
                        onClick={() => handleEditClinicLabProfile(item)}
                      >
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="text-danger"
                        onClick={() => handleDeleteClick(item)}
                      >
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="card-body p-0 pb-3">
                  <ul className="list-group list-group-flush">
                    <li className={classNames(styles.list, "list-group-item")}>
                      <span className="mb-0 title">Client Price</span> :
                      <span className="text-black ms-2">
                        {item?.clientPrice}
                      </span>
                    </li>
                    <li className={classNames(styles.list, "list-group-item")}>
                      <span className="mb-0 title">Patient Price</span> :
                      <span className="text-black ms-2">{item?.pt_price}</span>
                    </li>
                    <li className={classNames(styles.list, "list-group-item")}>
                      <span className="mb-0 title">Offer Price</span> :
                      <span className="text-black ms-2">
                        {item?.offerPrice}
                      </span>
                    </li>
                    <li className={classNames(styles.list, "list-group-item")}>
                      <span className="mb-0 title">Discount</span> :
                      <span className="text-black ms-2">
                        {item?.discount} %
                      </span>
                    </li>
                    <li className={classNames(styles.list, "list-group-item")}>
                      <span className="mb-0 title">Tax</span> :
                      <span className="text-black ms-2">{item?.tax} %</span>
                    </li>
                    <li className={classNames(styles.list, "list-group-item")}>
                      <span className="mb-0 title">Status</span> :
                      <span className="text-black ms-2">{item?.status}</span>
                    </li>
                    <b className={styles.clinicName}>Test Names:</b>
                    {testProfileList && testProfileList.length > 0 ? (
                      <>
                        {testProfileList.slice(0, 2).map((test, index) => (
                          <li
                            className={classNames(
                              styles.list,
                              "list-group-item",
                            )}
                            key={index}
                          >
                            <TbTestPipe className="ms-2" />
                            <span className="text-black ms-2">{test}</span>
                          </li>
                        ))}
                        {testProfileList.length > 2 && (
                          <li
                            className={classNames(
                              styles.list,
                              "list-group-item",
                            )}
                          >
                            <b className="mb-0 title">
                              +{testProfileList.length - 2} More Tests
                            </b>
                          </li>
                        )}
                      </>
                    ) : (
                      <li
                        className={classNames(styles.list, "list-group-item")}
                      >
                        <span className="text-muted">No tests selected</span>
                      </li>
                    )}

                    <div
                      className={styles.viewMoreWrapper}
                      onClick={() => handleViewAllclinicTestProfile(item?._id)}
                    >
                      <p>
                        View All Tests <FaChevronRight />
                      </p>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );

  const handleViewAllclinicTestProfile = (value) => {
    dispatch(
      getClinicPackageById({
        id: value,
        token,
        status: ["Active", "Inactive"],
      }),
    );
    setViewAllclinicPackage(true);
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    dispatch(
      getClinicPackage({
        searchQuery: e.target.value,
        token,
        status: ["Active", "Inactive"],
        clinicId,
      }),
    );
  };

  return (
    <>
      {heading()}
      {clinicPackageMaster?.length > 0 ? (
        clinicPackageMasterList()
      ) : (
        <h5 className="text-center mt-5">{"searchMessage"}</h5>
      )}
      <ViewAllTest
        setViewAllclinicPackage={setViewAllclinicPackage}
        viewAllclinicPackage={viewAllclinicPackage}
        clinicPackageMasterById={clinicPackageMasterById}
      />
      {/* Add and Update Country Modal */}
      <AddUpdatePackageMaster
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        clinicPackageFormData={clinicPackageFormData}
        handleAddOrUpdatePackage={handleAddOrUpdatePackage}
        selectedAction={selectedAction}
        handlesetClinicPackageFormData={handlesetClinicPackageFormData}
        clinicTestMasterByClinicId={clinicTestMasterByClinicId}
        pathologyServices={pathologyServices}
        setInputError={setInputError}
      />
      {/* delete Modal */}
      <Modal
        centered
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        size={"md"}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Confirm Delete
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>
            Are you sure you want to delete the Package{" "}
            <strong className="text-dark">
              {clinicPackageFormData?.packageName}
            </strong>
            ?
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModal(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleConfirmDelete}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ClinicTestProfile;
